import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ScreenSizeDetectorService, UiKitModule } from '@serviceplan/ui-kit';
import { accessAsset, anyAsset, AssetUIModel, ClientCoreModule, ClientEnvironment, ENVIRONMENT } from '@thehubz/client/core';
import { Asset } from '@thehubz/client/data-access-api';
import { CustomClients } from '@thehubz/shared/branding';
import { AnyType } from '@thehubz/shared/model';

@Component({
  selector: 'thehubz-action-buttons',
  standalone: true,
  imports: [MatIconModule, CommonModule, UiKitModule, ClientCoreModule],
  templateUrl: './action-buttons.component.html',
})
export class ActionButtonsComponent {
  @Input() asset!: AssetUIModel;
  @Input() assetIndex!: number;
  @Input() configObject!: AnyType;
  @Input() collectionOwner = false;

  @Output() addToCollection = new EventEmitter();
  @Output() editAssets = new EventEmitter<string>();
  @Output() shareAsset = new EventEmitter<AssetUIModel>();
  @Output() removeFromCollection = new EventEmitter<string>();
  @Output() downloadAsset = new EventEmitter<{ asset: AssetUIModel; name: string }>();
  @Output() deleteAsset = new EventEmitter<{ asset: AssetUIModel; id: string; planDeletionFlag?: boolean }>();

  AnyAsset = anyAsset;
  AccessAsset = accessAsset;
  Status = Asset.StatusEnum;
  brandingKey!: CustomClients;
  CustomClients = CustomClients;

  constructor(
    @Inject(ENVIRONMENT) env: ClientEnvironment,
    protected screenSizeDetectorService: ScreenSizeDetectorService,
  ) {
    this.brandingKey = env.brandingKey ?? CustomClients.Standard;
  }
}
